import React, {
  FC,
} from 'react';
import { ColumnCenter } from './Styles';
import SquadRegularText from '../../../../../components/Text/SquadRegularText';
import PingFangSemiBoldText from '../../../../../components/Text/PingFangSemiBoldText';
import PingFangRegularText from '../../../../../components/Text/PingFangRegularText';
import SquadExtraBoldText from '../../../../../components/Text/SquadExtraBoldText';
import CabBoxOpenedImage from '../../../../../components/CabBoxOpenedImage/Driver';
import SquadSemiBoldItalicText from '../../../../../components/Text/SquadSemiBoldItalicText';
import RowCenter from '../../../../../components/Layout/RowCenter';

const OpenedBox: FC<Props> = ({
  style,
  width,
  isEnglish,
  cabSizeType,
  lockAddress,
  lockPort,
  boxNumber,
}) => {
  return (
    <div
      style={{
        width,
        margin: '21px auto 21px auto',
        textAlign: 'center',
        background: '#F3F3F3',
        borderRadius: 17,
        ...style,
      }}
    >
      <RowCenter>
        <ColumnCenter style={{ width: 203, marginRight: 10 }}>
          {
            isEnglish ? (
              <ColumnCenter>
                <SquadRegularText fontSize={18} lineHeight={20}>Cubicle has opened in</SquadRegularText>
                <RowCenter>
                  <SquadRegularText fontSize={18} lineHeight={20}>the</SquadRegularText>
                  <SquadSemiBoldItalicText fontSize={18} lineHeight={20} textAlign={'center'} marginLeft={5}>
                    {cabSizeType === 'large' ? 'Large' : 'Regular'} Locker:
                  </SquadSemiBoldItalicText>
                </RowCenter>
              </ColumnCenter>
            ) : (
              <ColumnCenter>
                <PingFangRegularText fontSize={18} lineHeight={20}>{cabSizeType === 'large' ? '加大尺寸智能柜' : '普通尺寸智能柜'}柜门</PingFangRegularText>
                <PingFangSemiBoldText fontSize={18} lineHeight={20} textAlign={'center'} marginTop={5}>
                  已打开：
                </PingFangSemiBoldText>
              </ColumnCenter>
            )
          }
          <SquadExtraBoldText fontSize={46} color={'#00B595'} marginTop={15}>
            #{Number(boxNumber) < 10 ? '0' + boxNumber : boxNumber}
          </SquadExtraBoldText>
          {
            isEnglish ? (
              <SquadRegularText fontSize={12} lineHeight={15} textAlign={'center'} marginTop={10} opacity={0.5}>
                Located the {cabSizeType === 'large' ? 'Large' : 'Regular'} Locker and place the order into the open cubicle.
              </SquadRegularText>
            ) : (
              <PingFangRegularText fontSize={12} lineHeight={17} textAlign={'center'} marginTop={10} opacity={0.5}>
                请找到当前柜门并将订单放入打开的柜门中。
              </PingFangRegularText>
            )
          }
        </ColumnCenter>

        {/* 柜门打开示意图 */}
        <ColumnCenter style={{ paddingTop: 15, paddingBottom: 15 }}>
          <CabBoxOpenedImage
            cabSizeType={cabSizeType}
            lockAddress={lockAddress}
            lockPort={lockPort}
            width={101}
          />
        </ColumnCenter>
      </RowCenter>
    </div>
  );
};

export interface Props {
  style?: React.CSSProperties;
  width: number;
  isEnglish: boolean;
  cabSizeType: string;
  lockAddress: number;
  lockPort: number;
  boxNumber: string;
}

export default OpenedBox;
